import React from 'react';
import { route } from '../../routing/navigation';

import { getDefaultRoute } from '../../constants/routes.config';

import { LOGIN_LOGO_IMAGE } from '../../routes/auth/auth.tokens';
import {
    LogoButton,
    LogoImage,
    Panel,
    PanelBackground,
    PanelContent,
    PanelTagline,
} from './InformationPanel.styled';

const InformationPanel = () => (
        <Panel data-testid="information-panel">
            <PanelBackground data-testid="information-panel-hero" aria-hidden="true" />
            <PanelContent>
                <LogoButton
                    type="button"
                    onClick={() => route(getDefaultRoute())}
                >
                    <LogoImage
                        src={LOGIN_LOGO_IMAGE}
                        alt="LYT"
                    />
                </LogoButton>
                <PanelTagline>
                    Connect and Move.
                </PanelTagline>
            </PanelContent>
        </Panel>
);

export default InformationPanel;
